export function referralProgress(stats = {}) {
  const completed = Math.max(0, stats.totalCompleted ?? 0);
  const reward = Math.max(0, stats.creditsPerReferral ?? 250);
  const cap = Number.isFinite(stats.maxReferrals) ? Math.max(0, stats.maxReferrals) : null;
  const atCap = cap !== null && completed >= cap;
  const milestones = stats.milestoneBonuses?.enabled ? stats.milestoneBonuses.milestones ?? [] : [];
  const goals = [...new Set([1, 3, 5, 10, 25, cap, ...milestones.map(item => item.referrals)]
    .filter(value => value > 0 && (cap === null || value <= cap)))].sort((a, b) => a - b);
  const nextGoal = atCap ? cap : goals.find(value => value > completed) ?? Math.ceil((completed + 1) / 5) * 5;
  const remaining = Math.max(0, nextGoal - completed);
  const nextBonus = milestones.filter(item => item.status === 'upcoming' && item.referrals > completed && item.referrals <= nextGoal)
    .reduce((sum, item) => sum + item.credits, 0);
  return { completed, reward, cap, atCap, nextGoal, remaining, nextBonus, nextCredits: remaining * reward + nextBonus };
}

// Keep attribution outside the editable message so every share includes the link.
export function referralMessage(draft, link) {
  return [draft.trim(), link].filter(Boolean).join('\n\n');
}

export function referralShareUrl(channel, message, subject, platform) {
  const text = encodeURIComponent(message);
  switch (channel) {
    case 'gab': return `https://gab.com/compose?text=${text}`;
    case 'twitter': return `https://x.com/intent/tweet?text=${text}`;
    case 'email': return `mailto:?subject=${encodeURIComponent(subject)}&body=${text}`;
    case 'sms': return `sms:${platform === 'ios' ? '&' : '?'}body=${text}`;
    default: return null;
  }
}

export function referralText(t, key, values = {}) {
  return Object.entries(values).reduce((text, [name, value]) => (
    text.split(`%${name}%`).join(String(value))
  ), t(`settings.referral.${key}`));
}
